import { render, staticRenderFns } from "./VendorCharges.vue?vue&type=template&id=afca7e40&scoped=true"
import script from "./VendorCharges.vue?vue&type=script&lang=js"
export * from "./VendorCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afca7e40",
  null
  
)

export default component.exports